import { createSelector } from 'reselect';

// Config
import {
  getClickAndCollectCountdownVisibleSelector,
  getCollectionDateTimeStringSelector,
  getCollectionPointDatesApiCallActiveSelector,
  getCollectionPointDetailsCallActiveSelector,
  getCutOffTimeSelector,
} from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import {
  getDeliveryOptionsSelector,
  getDeliveryOptionsCollectionPlusAvailableSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { getUserSavedCollectionPointsSelector } from '@redux/reducers/user/userSelector';
import { getContinueButtonSecureIconFeatureActive } from '@redux/reducers/config/configSelector';

const clickAndCollectSelectedPointState = createSelector(
  [
    getCollectionDateTimeStringSelector,
    getClickAndCollectCountdownVisibleSelector,
    getCutOffTimeSelector,
    getDeliveryOptionsSelector,
    getUserSavedCollectionPointsSelector,
    getCollectionPointDetailsCallActiveSelector,
    getCollectionPointDatesApiCallActiveSelector,
    getDeliveryOptionsCollectionPlusAvailableSelector,
    getContinueButtonSecureIconFeatureActive,
  ],
  (
    collectFromTime,
    countdownVisible,
    cutOffTimeForSelectedStore,
    deliveryOptions,
    savedCollectionPoints,
    getCollectionPointDetailsCallActive,
    getCollectionPointDatesApiCallActive,
    collectPlusAvailable,
    showSecureIcon,
  ) => ({
    collectFromTime,
    countdownVisible,
    cutOffTimeForSelectedStore,
    deliveryOptions,
    savedCollectionPoints,
    isSelectCollectionPointCallActive: getCollectionPointDetailsCallActive || getCollectionPointDatesApiCallActive,
    collectPlusAvailable,
    showSecureIcon,
  }),
);

export default clickAndCollectSelectedPointState;
